import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-slate-50">
        <div className="text-slate-500 text-sm" data-testid="protected-loading">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && roles.length && !roles.includes(user.role)) {
    // Redirect user to their own dashboard
    const target =
      user.role === "admin" ? "/admin" : user.role === "teacher" ? "/teacher" : "/dashboard";
    return <Navigate to={target} replace />;
  }
  return children;
}
